import React, {Component} from "react"

import TicketInstructions from "@irati-web/perks/src/components/Tickets/TicketInstructions"
import {injectIntl, InjectIntl, FormattedMessage} from "@irati/utils/lang"
// @todo move TicketInstructions to ui folder and refactor to typescript
import Expand from "@irati/ui/src/Expander"

import {Label1} from "@irati/ui/src/Labels"
import {InstructionHeader, HeaderWrapper, RewardAvatar, Title, SubTitle, Message, StyledInstructions} from "./styled"

interface Props extends InjectIntl {
  title: string,
  thumbnailImage: string,
  message: string | null,
  subtitle?: string,
  instructions?: string,
  termsAndConditions?: string
}

class PopUpHeader extends Component<Props> {
  static defaultProps = {
    subtitle: null,
    instructions: null,
    termsAndConditions: null
  }

  render() {
    const {title, subtitle, thumbnailImage, instructions, termsAndConditions, message, formatMessage} = this.props
    return (
      <HeaderWrapper>
        <RewardAvatar src={thumbnailImage} alt={title} marginTop={-2} large withShadow />
        <Title>{title}</Title>
        {subtitle && <SubTitle>{subtitle}</SubTitle>}
        {message && <Message>{message}</Message>}
        {instructions && (
          <>
            <InstructionHeader>
              <FormattedMessage id="recognition.account.rewards.instructionHeader" />
            </InstructionHeader>
            <div>
              <Expand
                hideText={formatMessage({id: "recognition.account.rewards.hideInstructions"})}
                showText={formatMessage({id: "recognition.account.rewards.viewInstructions"})}
                HeaderLabel={Label1}>
                <StyledInstructions>
                  <TicketInstructions instructions={instructions} />
                </StyledInstructions>
              </Expand>
            </div>
          </>
        )}
        {termsAndConditions && (
          <div>
            <Expand
              hideText={formatMessage({id: "recognition.account.rewards.hideTerms"})}
              showText={formatMessage({id: "recognition.account.rewards.viewTerms"})}
              HeaderLabel={Label1}>
              <StyledInstructions>
                <TicketInstructions instructions={termsAndConditions} />
              </StyledInstructions>
            </Expand>
          </div>
        )}
      </HeaderWrapper>
    )
  }
}
export default injectIntl(PopUpHeader)
